<!--  -->
<template>
  <div>
    <div class="header">
      <el-form inline>
        <el-form-item label="关键词：">
          <el-input v-model="form.key" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="文章标题：">
          <el-input v-model="form.title" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="产品标签：">
          <el-select v-model="form.tags" multiple placeholder="请选择">
            <el-option
              v-for="item in productData"
              :key="item.id"
              :label="item.product_name"
              :value="item.id"
              clearable="true"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="评论状态：">
          <el-select v-model="form.status" multiple placeholder="请选择">
            <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              clearable="true"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="screening">筛选</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-list">
      <el-table :data="tableData" v-loading="tableLoading" :row-class-name="tableRowClassName">
        <el-table-column label="评论内容">
          <template slot-scope="scope">
            <Ellipsis
              :str="scope.row.CommentContext"
              suffix="..."
              :max-length="20"
              expandable
            ></Ellipsis>
          </template>
        </el-table-column>
        <el-table-column label="文章标题">
          <template slot-scope="scope">
            <span class="text-button" @click="gotoUrl('article', scope.row)">
              {{ scope.row.ArtTitle }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="发布人">
          <template slot-scope="scope">
            <span
              :class="scope.row.CommentUserType === 3 ? '' : 'text-button'"
              @click="gotoUrl('user', scope.row)"
            >
              {{ scope.row.CommentUserName }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="发布时间" prop="PublishTime">
          <template slot-scope="scope">
            {{ scope.row.PublishTime | handleTime() }}
          </template>
        </el-table-column>

        <el-table-column label="产品标签" prop="ArtTags">
          <template slot-scope="scope">
            <p v-for="item in scope.row.ArtTags" :key="item">
              {{ item }}
            </p>
          </template>
        </el-table-column>

        <el-table-column label="渠道" prop="PublishChannel"></el-table-column>

        <el-table-column label="发布人分类">
          <template slot-scope="scope">
            {{ scope.row.CommentUserType | handleUserType() }}
          </template>
        </el-table-column>

        <el-table-column label="评论状态">
          <template slot-scope="scope">
            {{ scope.row.Status | handleStatus() }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <span
              class="operate-button"
              @click="AuditArticleComment(scope.row.CommentId, 2)"
              v-if="judgePass(scope.row.Status)"
            >
              通过
            </span>
            <span class="operate-button" v-else>-</span>
            <span
              class="operate-button"
              @click="AuditArticleComment(scope.row.CommentId, 3)"
              v-if="judgeReject(scope.row.Status)"
            >
              拒绝
            </span>
            <span class="operate-button" v-else>-</span>
          </template>
        </el-table-column>
      </el-table>

      <div style="margin-top: 20px; float: right">
        <el-pagination
          style="background-color: #ffffff"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          :page-sizes="g_pageSizesConfig"
          :page-size="page_size"
          :current-page="page_index"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { QueryArticleComments, AuditArticleComment } from '@/api/commentManagement.js';
import { mapQuery } from '@/utils/util';
import Ellipsis from '@/components/ellipsis';
import { GetProductInfoList } from '@/api/setUser';
export default {
  components: {
    Ellipsis,
  },
  filters: {
    handleTime(val) {
      const date = new Date(val * 1000 + 8 * 3600 * 1000);
      return date.toJSON().substr(0, 19).replace('T', ' ').replace(/-/g, '/');
    },
    handleStatus(val) {
      if (val === 1) {
        return '待审核';
      }
      if (val === 2) {
        return '已通过';
      }
      if (val === 3) {
        return '未通过';
      }
    },
    handleUserType(val) {
      if (val === 1) {
        return '员工';
      }
      if (val === 2) {
        return '医生';
      }
    },
    handleContext(val) {
      return val.substr(0, 20);
    },
  },
  data() {
    return {
      tableLoading: false,
      form: {
        key: '',
        tags: [],
        status: [],
      },
      productData: [],
      page_index: 1,
      page_size: this.g_pageSizeDefault,
      total: 0,
      tableData: [],
      statusOptions: [
        // 状态选择项
        {
          label: '待审核',
          value: 1,
        },
        {
          label: '已通过',
          value: 2,
        },
        {
          label: '未通过',
          value: 3,
        },
      ],
    };
  },
  created() {
    this.page_size = this.g_pageSizeDefault;
    this.getList();
    this.getProductList();
  },
  methods: {
    gotoUrl(type, data) {
      let url = '';
      if (type === 'article') {
        const id = data.ArtId;
        const componentName = /^[0-9]*$/.test(id) ? 'articleEditAgents' : 'articleEdit';
        url = `/saas/articleManagement.html${mapQuery({
          componentName,
          id: data.ArtId,
        })}`;
      } else if (type === 'user') {
        if (data.CommentUserType === 1) {
          // 是员工
          url = `/saas/representDetaill.html?id=${data.CommentUserId}`;
        } else if (data.CommentUserType === 2) {
          // 是医生
          url = `/saas/doctorInfo.html?doctor_id=${data.CommentUserId}`;
        }
      }
      // console.log('url123', url);
      this.g_tourl(url, { open: true });
    },
    judgePass(status) {
      return status === 1 || status === 3;
    },
    judgeReject(status) {
      return status === 1 || status === 2;
    },
    // 查询Product列表
    async getProductList() {
      this.tableLoading = true;
      try {
        const res = await GetProductInfoList();
        if (!res.error) {
          this.productData = []; // 清空当前列表
          this.productData = res.list;
        }
      } catch (error) {
        this.$message.error(error.message);
        this.tableLoading = false;
      }
      this.tableLoading = false;
    },
    screening() {
      this.page_index = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.page_size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page_index = val;
      this.getList();
    },
    tableRowClassName(row) {
      if (row.row.status === 3) {
        return 'warning-row';
      }
    },
    getList() {
      this.tableLoading = true;
      const req = {
        Status: this.form.status,
        Key: this.form.key,
        Title: this.form.title,
        Tags: this.form.tags,
        PageIndex: this.page_index,
        PageSize: this.page_size,
      };
      QueryArticleComments(req)
        .then((res) => {
          this.tableData = res.Comments;
          this.total = res.AllCount;
          this.tableLoading = false;
        })
        .catch(() => {
          this.$message.error('获取失败');
          this.tableLoading = false;
        });
    },
    AuditArticleComment(CommentId, Operate) {
      AuditArticleComment({
        CommentId,
        Operate,
      })
        .then(() => {
          this.getList();
        })
        .catch((e) => {
          this.$message.error(e);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep.el-table .warning-row {
  color: #c0c4cc;
}
.header {
  display: flex;
  align-items: top;
  border-bottom: 1px solid rgb(241, 241, 241);
}
.table-list {
  margin-top: 60px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  ::v-deep .el-table__header-wrapper .el-table__header {
    color: #303133;
    background: rgba(216, 216, 216, 0.1);
  }
  ::v-deep .el-table .cell {
    font-size: 16px;
  }
  ::v-deep .el-table__empty-text {
    line-height: 0;
  }
  .text-button {
    cursor: pointer;
    color: #2f96ff;
  }
  .operate-button {
    display: inline-block;
    width: 3em;
    text-align: center;
    color: #2f96ff;
    font-size: 16px;
    cursor: pointer;
  }
}
</style>
